<div class="bg-white" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'p-4' : 'px-0 px-sm-3 m-3'">
  <div class="item-center app-auth-header-icon" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'm-3' : 'm-5'">
    <div>
      <mat-icon svgIcon="falCircleUserCircleCheck" class="icon-center" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>
  </div>

  <div class="d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
    <span class="font-dialog-confirm-title text-center" [ngClass]="{'mobile-font-dialog-confirm-title': (srvRpDesign.isMobile$ | async)}">
      {{ data.title || ('APP_AUTHENTICATOR.ACTIVATE_TITLE' | translate) }}
    </span>
  </div>

  <div
    class="font-dialog-confirm-content"
    mat-dialog-content
    [ngClass]="(srvRpDesign.isMobile$ | async) ? 'my-3 p-0 mobile-font-dialog-confirm-content' : 'mt-4 mx-3'">
    <p class="text-left">
      {{ (isBrowser ? 'APP_AUTHENTICATOR.ACTIVATE_WEB_MESSAGE' : 'APP_AUTHENTICATOR.ACTIVATE_MESSAGE') | translate }}
    </p>
  </div>

  <div
    class="needs-activate-actions d-flex"
    mat-dialog-actions
    [class.has-two-actions]="!isBrowser"
    [ngClass]="(srvRpDesign.isMobile$ | async) ? 'gap-2' : 'my-3 gap-3'">
    @if (isBrowser) {
      <button class="font-button button-action-cancel p-4" mat-button cdkFocusInitial (click)="onBack()">
        {{ 'BUTTON_BACK' | translate }}
      </button>
    } @else {
      <button class="font-button button-action-cancel p-4" mat-button (click)="onCancel()">
        {{ 'BUTTON_CANCEL' | translate }}
      </button>
      <button class="font-button button-action-base p-4" mat-button cdkFocusInitial (click)="onContinue()">
        {{ 'BUTTON_CONFIRM' | translate }}
      </button>
    }
  </div>

  <div class="needs-activate-footer text-center mt-2">
    <span>{{ 'APP_AUTHENTICATOR.NEEDS_ACTIVATE_BROWSER_PHRASE2_BEFORE' | translate }}</span>
    <a class="needs-activate-link" href="javascript:void(0)" (click)="onSendCode(); $event.preventDefault()">
      {{ 'APP_AUTHENTICATOR.NEEDS_ACTIVATE_SEND_CODE' | translate }}
    </a>
  </div>
</div>
